import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/api-test/page.tsx");
